// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"121":"gallery","548":"calendar"}[chunkId] + "." + {"121":"4eb5c2ce","548":"3c006b79"}[chunkId] + ".css";
};